import { render, staticRenderFns } from "./RemoteDashboard.vue?vue&type=template&id=3d310d2c&scoped=true"
import script from "./RemoteDashboard.vue?vue&type=script&lang=js"
export * from "./RemoteDashboard.vue?vue&type=script&lang=js"
import style0 from "./RemoteDashboard.vue?vue&type=style&index=0&id=3d310d2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d310d2c",
  null
  
)

export default component.exports